import script from "./ProfileEducationDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEducationDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEducationDrawer.vue?vue&type=style&index=0&id=cd5c24a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd5c24a4"]])

export default __exports__